// src/shared/components/ui/Logo.tsx

import React from 'react';
import './Logo.css';

interface LogoProps {
  variant?: 'default' | 'white' | 'icon' | 'text';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({ 
  variant = 'default', 
  size = 'md',
  className = '',
  onClick 
}) => {
  const getLogoSrc = (): string | undefined => {
    switch (variant) {
      case 'white':
        return '/assets/images/logo/ibloom-logo-white.png';
      case 'icon':
        return '/assets/images/logo/ibloom-icon.png';
      case 'text':
        return undefined; // Solo texto
      default:
        return '/assets/images/logo/ibloom-logo.png';
    }
  };

  const logoClasses = [
    'logo',
    `logo--${variant}`,
    `logo--${size}`,
    onClick && 'logo--clickable',
    className
  ].filter(Boolean).join(' ');

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    // Fallback al logo de texto si la imagen no se encuentra
    const target = e.target as HTMLImageElement;
    target.style.display = 'none';
    
    // Mostrar el texto fallback
    const textFallback = target.nextElementSibling as HTMLElement;
    if (textFallback) {
      textFallback.style.display = 'block';
    }
  };

  if (variant === 'text') {
    return (
      <div 
        className={logoClasses}
        onClick={onClick}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
      >
        <span className="logo-text">IBLOOM</span>
      </div>
    );
  }

  return (
    <div 
      className={logoClasses}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {getLogoSrc() && (
        <img 
          src={getLogoSrc()} 
          alt="iBloom" 
          className="logo-image"
          onError={handleImageError}
        />
      )}
      <span className="logo-text-fallback" style={{ display: 'none' }}>
        IBLOOM
      </span>
    </div>
  );
};

export default Logo;